import styles from "./OptionButton.module.css";

const STATE_CLASS = {
  correct: styles.correct,
  wrong: styles.wrong,
  expected: styles.expected,
};

export default function OptionButton({ letter, text, state, locked, onClick }) {
  return (
    <button
      type="button"
      className={`${styles.option} ${STATE_CLASS[state] ?? ""}`}
      disabled={locked}
      aria-pressed={state === "correct" || state === "wrong"}
      onClick={onClick}
    >
      <span className={styles.letter}>{letter}</span>
      <span className={styles.text}>{text}</span>
      {state === "correct" && <span className={styles.tag}>✓</span>}
      {state === "wrong" && <span className={styles.tag}>×</span>}
      {state === "expected" && <span className={styles.tag}>KEY</span>}
    </button>
  );
}
